import { msgBroadcaster } from '@shared/WalletService'
import { sharedToBalanceInWei } from '@shared/utils/formatter'
import { TokenStatic, MsgExecuteContractCompat } from '@injectivelabs/sdk-ts'
import { backupPromiseCall } from '@/app/client/utils/async'

export const subscribeToIDO = async ({
  amount,
  quoteToken,
  contractAddress
}: {
  amount: string
  quoteToken: TokenStatic
  contractAddress: string
}) => {
  const walletStore = useWalletStore()
  const launchpadStore = useLaunchpadStore()
  const sharedWalletStore = useSharedWalletStore()

  if (
    !sharedWalletStore.isUserConnected ||
    !sharedWalletStore.defaultSubaccountId
  ) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    sender: sharedWalletStore.injectiveAddress,
    funds: [
      {
        denom: quoteToken.denom,
        amount: sharedToBalanceInWei({
          value: amount,
          decimalPlaces: quoteToken.decimals
        }).toFixed()
      }
    ],
    contractAddress,
    exec: {
      action: 'Subscribe',
      msg: {}
    }
  })

  const tx = await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  backupPromiseCall(() => launchpadStore.fetchIDOSubscription(contractAddress))

  return tx
}

export const claimIDORewards = async ({
  contractAddress
}: {
  contractAddress: string
}) => {
  const walletStore = useWalletStore()
  const launchpadStore = useLaunchpadStore()
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.isUserConnected) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    contractAddress,
    sender: sharedWalletStore.injectiveAddress,
    exec: {
      action: 'Claim',
      msg: {}
    }
  })

  const tx = await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  backupPromiseCall(() => launchpadStore.fetchIDOSubscription(contractAddress))

  return tx
}

export const instantiateVestingClaim = async ({
  contractAddress
}: {
  contractAddress: string
}) => {
  const walletStore = useWalletStore()
  const launchpadStore = useLaunchpadStore()
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.isUserConnected) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    contractAddress,
    sender: sharedWalletStore.injectiveAddress,
    exec: {
      action: 'Claim',
      msg: {}
    }
  })

  await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  backupPromiseCall(() => launchpadStore.fetchClaimReference(contractAddress))
  backupPromiseCall(() => launchpadStore.fetchIDOSubscription(contractAddress))
}

export const claimVestedRewards = async ({
  cwContractAddress,
  idoContractAddress
}: {
  cwContractAddress: string
  idoContractAddress: string
}) => {
  const walletStore = useWalletStore()
  const launchpadStore = useLaunchpadStore()
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.isUserConnected) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    contractAddress: cwContractAddress,
    sender: sharedWalletStore.injectiveAddress,
    exec: {
      action: 'distribute',
      msg: {}
    }
  })

  const tx = await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  backupPromiseCall(() =>
    launchpadStore.fetchClaimReference(idoContractAddress)
  )

  return tx
}
